/**
 * The ONE way this app reads an email out of a form.
 *
 * An email is a case-insensitive identity, and the platform stores it
 * lowercased in a single `email` field - so what the doors send to Firebase
 * Auth has to match what the backend will store, or the same person typing
 * `Aoife@example.ie` at sign-up and `aoife@example.ie` at sign-in would be
 * two different logins. Trim the stray space a keyboard adds, fold the case,
 * and every door speaks the same address.
 */
export function normaliseEmail(value: string): string {
  return value.trim().toLowerCase();
}
